import ScrollMagic from 'scrollmagic';
import {IAModal} from '../../../blocks/internet-acquiring-style/internet-acquiring-style';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__solutions-features--acquiring',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__solutions-features--acquiring .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__section--omnichinality',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__section--omnichinality .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__section--acquiring-works',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__section--acquiring-works .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__section--acquiring-type',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__section--acquiring-type .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__section--acquiring-keys',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__section--acquiring-keys .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__connect',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__connect .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);


    new IAModal('.js-open-modal-works');
});



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/internet-acquiring.js